import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MedicalTool } from "../../../../entities/tools/medical-tool";

@Component({
	selector: "app-medical-tool-viewer-dialog",
	imports: [MatDialogModule, MatButtonModule],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./medical-tool-viewer-dialog.component.html",
})
export class MedicalToolViewerDialogComponent {
	protected tool = inject<MedicalTool>(MAT_DIALOG_DATA);
	protected dialogRef = inject(MatDialogRef<MedicalToolViewerDialogComponent>);
	private sanitizer = inject(DomSanitizer);

	protected srcdoc: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(this.buildDocument());

	private buildDocument(): string {
		return (
			`<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<script src="https://cdn.tailwindcss.com"></` +
			`script>
<script>
    tailwind.config = {
        darkMode: 'class',
        corePlugins: { preflight: false }
    }
</` +
			`script>
<style>body { font-family: sans-serif; margin: 16px; }${this.tool.css ? `\n${this.tool.css}` : ""}</style>
</head>
<body>
${this.tool.html}
${this.tool.js ? `<script>${this.tool.js}</` + `script>` : ""}
</body>
</html>`
		);
	}
}
